import { render, staticRenderFns } from "./EmbroideryPositionForm.vue?vue&type=template&id=1ce8f6b8&"
import script from "./EmbroideryPositionForm.vue?vue&type=script&lang=js&"
export * from "./EmbroideryPositionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports